import { render, staticRenderFns } from "./movieDetail.vue?vue&type=template&id=0e260a9c&scoped=true&"
import script from "./movieDetail.vue?vue&type=script&lang=js&"
export * from "./movieDetail.vue?vue&type=script&lang=js&"
import style0 from "./movieDetail.vue?vue&type=style&index=0&id=0e260a9c&prod&lang=less&scoped=true&"
import style1 from "./movieDetail.vue?vue&type=style&index=1&id=0e260a9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e260a9c",
  null
  
)

export default component.exports